export const ASKABLE_TERMS_URL = 'https://www.askable.com/legal/terms';
export const ASKABLE_PRIVACY_URL = 'https://www.askable.com/legal/privacy-policy';

// Intercom survey ID used across clients and sessions.
// We keep it as a constant here (instead of environment variables) since we don’t maintain
// a dev Intercom setup and only need a single shared value for production.
export const ASKABLE_INTERCOM_SURVEY = '52392950';

// Askable Labs Studio, where the expert/novice scripts live.
export const ASKABLE_STUDIO_URL = 'https://studio.askablelabs.com';

/**
 * The Studio page an expert/novice pair works a session from. Written down once so the clients
 * session-page template and the room's link out to Studio cannot drift apart.
 *
 * The values are interpolated raw rather than encoded: the clients template passes the backend's
 * `{{booking_id}}` / `{{session_code}}` placeholders through here, and encoding would leave the
 * backend nothing it recognises to substitute.
 */
export const studioExpertNoviceSessionUrl = ({
  bookingId,
  sessionCode,
  ready = false,
}: {
  bookingId: string;
  sessionCode: string;
  /**
   * Land on the scripts rather than on Studio's "join the call" launcher. True for a link handed to
   * someone already in the call; the launcher would only send them back to the room they are in.
   */
  ready?: boolean;
}) => {
  const readyParam = ready ? '&ready=1' : '';
  return `${ASKABLE_STUDIO_URL}/participant/expert-novice-session?external_id=${bookingId}&session=${sessionCode}${readyParam}`;
};
